import type { ValueOf } from 'type-fest';

export const themes = {
  centered: 'centered',
  overlay: 'overlay',
  overlayBlue: 'overlay-blue',
  overlaySticky: 'overlay-sticky',
} as const;

export const sizes = {
  medium: 'medium',
  mini: 'mini',
};

export type Spinner = {
  size?: ValueOf<typeof sizes>;
  theme?: ValueOf<typeof themes>;
};
